import { render } from "./ptStatistics.vue?vue&type=template&id=5f855c96&scoped=true"
import script from "./ptStatistics.vue?vue&type=script&lang=js"
export * from "./ptStatistics.vue?vue&type=script&lang=js"

import "./ptStatistics.vue?vue&type=style&index=0&id=5f855c96&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f855c96"]])

export default __exports__